// Generated file - do not change manually!

/**
 * Defines the <code>ui5-title</code> level
 */
export enum TitleLevel {
  /**
   * Renders <code>h1</code> tag.
   */
  H1 = 'H1',

  /**
   * Renders <code>h2</code> tag.
   */
  H2 = 'H2',

  /**
   * Renders <code>h3</code> tag.
   */
  H3 = 'H3',

  /**
   * Renders <code>h4</code> tag.
   */
  H4 = 'H4',

  /**
   * Renders <code>h5</code> tag.
   */
  H5 = 'H5',

  /**
   * Renders <code>h6</code> tag.
   */
  H6 = 'H6'
}
